import standard from './themes/standard';
import fontRoboto from './themes/font-roboto';
import hu from './lang/hu';
import en from './lang/en';
function configure(hc) {
    standard(hc);
    fontRoboto(hc);
    hc.setLang = function (lang) {
        if (lang === 'en') {
            en(hc);
        }
        else {
            hu(hc);
        }
    };
}
export default configure;
